export interface DynamicFieldConfig {
  formType: string;
  fieldKey: string;
  itemLabel: string;
}

export const DYNAMIC_FIELDS_CONFIG: DynamicFieldConfig[] = [
  {
    formType: "w2",
    fieldKey: "box14_comp_codes",
    itemLabel: "Box 14 - Other",
  },
  {
    formType: "w2",
    fieldKey: "state_tax_items",
    itemLabel: "State Tax Items",
  },
  {
    formType: "1095a",
    fieldKey: "coverage_information",
    itemLabel: "Coverage Information",
  },
  {
    formType: "1099div",
    fieldKey: "state_items",
    itemLabel: "State Tax Information",
  },
  {
    formType: "1099int",
    fieldKey: "state_entries",
    itemLabel: "State Tax Information",
  },
  {
    formType: "1099misc",
    fieldKey: "state_items",
    itemLabel: "State Tax Information",
  },
];

export const getDynamicFieldConfig = (
  formType: string | null,
  fieldKey: string
): DynamicFieldConfig | undefined => {
  if (!formType) return undefined;

  // Try exact match first
  let config = DYNAMIC_FIELDS_CONFIG.find(
    (config) => config.formType === formType && config.fieldKey === fieldKey
  );

  // If no match, try case-insensitive match
  if (!config) {
    config = DYNAMIC_FIELDS_CONFIG.find(
      (config) =>
        config.formType.toLowerCase() === formType.toLowerCase() &&
        config.fieldKey === fieldKey
    );
  }

  return config;
};

export const canAddItems = (
  formType: string | null,
  fieldKey: string
): boolean => {
  return getDynamicFieldConfig(formType, fieldKey) !== undefined;
};
